import { parseUrl } from "./util";
import request from "./request";

export const getBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
        const base64 = reader.result;
        const name = file.name;
        const size = file.size;
        const type =
            base64
                .split(",")[0]
                .split(";")[0]
                .split(":")[1] || file.type;
        const blob = base64.split(",")[1] || [];
        callback({ blob, type, name, size: size });
    });
    reader.readAsDataURL(file);
};

export const download = ({ file }) => {
    const { saveAs } = require("file-saver");
    if (file.url) {
        if (file.isUserFile) {
            request.get(parseUrl(file.url), { responseType: "blob" }).then(blob => saveAs(blob, file.name));
        } else {
            saveAs(parseUrl(file.url), file.name);
        }
    } else if (file.blob && file.type) {
        saveAs(`data:${file.type};base64,${file.blob}`, file.name);
    }
};

export const niceBytes = byte => {
    const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let l = 0,
        n = parseInt(byte, 10) || 0;
    while (n >= 1024 && ++l) {
        n = n / 1024;
    }
    return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
};
